$(() => {
  const DEFAULT_RADIUS = 50;

  function setupGoogleMapAutoComplete() {
    const input = document.getElementById('position-location-search');
    if (!input) return;
    const searchBox = new google.maps.places.Autocomplete(input);

    searchBox.addListener('place_changed', () => {
      const place = searchBox.getPlace();

      if (place === undefined) {
        $('#position-location-search-lat').val('');
        $('#position-location-search-lng').val('');
        return;
      }

      const location = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };

      $('#position-location-search-lat').val(location.lat);
      $('#position-location-search-lng').val(location.lng);
    });
  }

  google.maps.event.addDomListener(window, 'load', setupGoogleMapAutoComplete);

  function searchPositions(radius) {
    const title = $('#position-title-search').val();
    let lat = $('#position-location-search-lat').val();
    let lng = $('#position-location-search-lng').val();
    const location = $('#position-location-search').val();
    const hasLocation = location.length > 0;

    if (!hasLocation) {
      lat = '';
      lng = '';
    }

    searchQuery = {
      page: 1,
      radius: hasLocation && radius !== 'all' ? radius || DEFAULT_RADIUS : null,
      title: encodeURIComponent(title),
      lat: encodeURIComponent(lat),
      lng: encodeURIComponent(lng),
      geo: encodeURIComponent(location),
    };

    if (typeof (isNewUrl) !== 'undefined' && isNewUrl && searchBaseUrl) {
      updateSearchQueryStringParamsWithNewUrl(searchBaseUrl, searchQuery);
    } else {
      updateSearchQueryStringParams(slug, searchQuery);
    }
  }

  $('.search-position').click((e) => {
    e.preventDefault();
    searchPositions($('#search-radius').val());
  });

  $('#position-title-search, #position-location-search').keypress((e) => {
    const key = e.which;
    if (key == 13) {
      searchPositions($('#search-radius').val());
      return false;
    }
  });

  $('#search-radius').selectpicker('val', query.radius || (query.geo ? 'all' : DEFAULT_RADIUS));

  if (query.geo) {
    $('#position-location-search').val(query.geo);
  } else {
    $('#position-location-search').val('');
  }
});
